function Goback(){

   if (screen.width <= 769) {
       console.log("mob tester");
     
     document.getElementById("target").scrollIntoView();
    console.log("Goback"); 
     var scrollDiv = document.getElementById("target").offsetTop;
     console.log("scrollDiv mob", scrollDiv);
      window.scrollTo({ top: scrollDiv - 200, behavior: 'smooth'});
    }
    else{
       console.log("web tester");
     
     document.getElementById("target").scrollIntoView();
    console.log("Goback"); 
     var scrollDiv = document.getElementById("target").offsetTop;
      window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
    }
  
   }

